{
    "image": "https://www.cm.com/app/aurora/svg/images/light/aurora-error.svg"
}
